/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Pages_Confirm_Upgrade_Btn_NewInputs */



/**
* | output |
* | --- |
* | "Add pages" |
*
* @param {Sub_Addons_Pages_Confirm_Upgrade_Btn_NewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_pages_confirm_upgrade_btn_new = /** @type {((inputs?: Sub_Addons_Pages_Confirm_Upgrade_Btn_NewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Pages_Confirm_Upgrade_Btn_NewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seiten hinzufügen")
	return /** @type {LocalizedString} */ ("Add pages")
});